module.exports = __webpack_public_path__ + "static/media/saas-sketch-1.fc8ce18f.svg";